module.exports = __webpack_public_path__ + "static/media/connection-implants-english.58422047.png";